const getUserSessionData = (sessionData) => sessionData.get('user');
const getClientSessionData = (sessionData) => sessionData.get('client');
const getTokenData = (sessionData) => sessionData.get('tokens');
const getMfaData = (sessionData) => sessionData.get('mfa');

export {getUserSessionData, getClientSessionData, getTokenData, getMfaData}